module.exports = __webpack_public_path__ + "static/media/IMG_20190130_113615149.29385fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_20190130_113615149.jpg
// module id = 49
// module chunks = 0